import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { fetchAuthSession } from 'aws-amplify/auth';
import * as FileSaver from 'file-saver';
import {
  catchError,
  concatMap,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  tap
} from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SERVICE_TYPES } from '../service-types';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-dialog-archivos-reservas',
  templateUrl: './dialog-archivos-reservas.component.html',
  styleUrls: ['./dialog-archivos-reservas.component.css']
})
export class DialogArchivosReservasComponent implements OnInit {
  // s3ServiceRoute:any="https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/operations/api/v1";
  s3ServiceRoute: any = `${environment.operationsApi}/api/v1`;
  multimedia: any = [];
  archivos: any = [];
  isLoading: boolean = true;
  pdfViewer: any = false;
  index: any;
  url: any;
  messageResult: String = '';
  iconResult: any;
  uploading: boolean = false;
  hasDocument: boolean = false;
  hasInvalidFechaOperacion: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private fileService: FileService,
    public dialogRef: MatDialogRef<DialogArchivosReservasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    public dialog: MatDialog
  ) {
    if (data.multimediaItinerary?.length > 0) {
      this.multimedia = data.multimediaItinerary;
      this.isLoading = false;
    }
    if (data.hasDocument) this.hasDocument = data.hasDocument;
    this.hasInvalidFechaOperacion = data.hasInvalidFechaOperacion;
  }

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      if (!token) {
        console.error('No access token available');
        throw new Error('No access token available');
      }

      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      });
    } catch (error) {
      console.error('Error getting auth token:', error);
      throw error; // Re-lanzar el error para que sea manejado por el método que lo llama
    }
  }

  ngOnInit(): void {
    if (this.multimedia?.length === 0) this.getAllMultimedia();
  }

  getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  async onFileSelected(event: any) {
    if (!event.target.files) return;

    this.uploading = true;
    const maxSize = 4000000;
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'image/jpeg',
      'image/png'
    ];

    const uploadRequests: Observable<any>[] = [];

    const files = Array.from(event.target.files) as File[];

    const base64Promises = files.map(
      (file) =>
        new Promise<{ file: File; base64: string }>((resolve, reject) => {
          if (file.size > maxSize) {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Archivo demasiado grande',
              text: `El archivo ${file.name} supera los 4MB.`,
              showConfirmButton: false,
              timer: 4000
            });
            return reject(null);
          }

          if (!allowedTypes.includes(file.type)) {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Error al subir',
              text: `Este formato no está soportado: ${file.name}`,
              showConfirmButton: false,
              timer: 4000
            });
            return reject(null);
          }

          this.getBase64(file, (result: any) => {
            resolve({ file, base64: result });
          });
        })
    );

    let newImage: {
      key: any;
      name: any;
      nameDownload: any;
      src?: string;
    } = {
      key: '',
      name: '',
      nameDownload: '',
      src: ''
    };

    try {
      const headers = await this.getAuthHeaders();

      const results = await Promise.allSettled(base64Promises);

      results.forEach((res) => {
        if (res.status === 'fulfilled') {
          const { file, base64 } = res.value;
          let upload;

          switch (this.data.serviceType) {
            case 1:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFile`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 2:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileTransporte`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 3:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileTren`,
                {
                  data: base64,
                  fileId: this.data.fileNumber,
                  serviceId: this.data.id,
                  fileName: file.name,
                  fecha: this.data.fecha
                },
                { headers }
              );
              break;
            case 4:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileGuias`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 5:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileOperadores`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 6:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileCoordinadores`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 7:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileHoteles`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 10:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileItinerary`,
                {
                  data: base64,
                  fileId: this.data.id,
                  fileName: file.name
                },
                { headers }
              );
              break;
            case 11:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileTemplate`,
                {
                  data: base64
                },
                { headers }
              );
              break;
            case SERVICE_TYPES.TICKET:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileTicket`,
                {
                  data: base64,
                  fileId: this.data.fileId,
                  serviceId: this.data.serviceId,
                  ticketId: this.data.id,
                  fileName: file.name,
                  fecha: this.data.fecha
                },
                { headers }
              );

              break;
            default:
              upload = this.http.post(
                `${this.s3ServiceRoute}/addFileReserva`,
                {
                  data: base64,
                  reservaId: this.data.reservaId,
                  fileName: file.name
                },
                { headers }
              );
          }

          newImage = {
            src: base64,
            name: file.name,
            nameDownload: file.name,
            key: ''
          };

          uploadRequests.push(
            upload.pipe(
              concatMap((response: any) => {
                const s3Key = response.payload?.Key || response.key;
                newImage.key = s3Key;
                if (
                  this.data.serviceType === SERVICE_TYPES.TICKET &&
                  response.fechaStatus !== null &&
                  response.fechaStatus !== undefined
                ) {
                  if (response.fechaStatus === true) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Fechas coinciden',
                      text: 'La fecha del documento coincide con la fecha del servicio.',
                      showConfirmButton: false,
                      timer: 4000
                    });
                  }

                  if (response.fechaStatus === false) {
                    this.isLoading = true;

                    const fileNameWithoutExt = newImage.name.substring(
                      0,
                      newImage.name.lastIndexOf('.')
                    );
                    const fileExtension = newImage.name.substring(
                      newImage.name.lastIndexOf('.')
                    );
                    const newKey = s3Key.replace(
                      newImage.name,
                      `${fileNameWithoutExt} - FECHA DE OPERACION NO COINCIDE${fileExtension}`
                    );

                    newImage.name = `${newImage.name} - FECHA DE OPERACION NO COINCIDE`;
                    newImage.nameDownload = `${newImage.nameDownload} - FECHA DE OPERACION NO COINCIDE`;
                    newImage.key = newKey;

                    if (
                      this.data.isTicketItinerarioService &&
                      !this.multimedia.some((m: any) =>
                        m.name.includes('FECHA DE OPERACION NO COINCIDE')
                      )
                    ) {
                      this.updateHasInvalidFechaOperacion(true);
                    }

                    if (
                      !this.multimedia.some((m: any) =>
                        m.name.includes('FECHA DE OPERACION NO COINCIDE')
                      )
                    ) {
                      let updateObservable;
                      if (!this.data.isTicketItineraryService) {
                        updateObservable =
                          this.fileService.updateServiceTicketValidFechaOperacion(
                            {
                              serviceId: this.data.id,
                              hasInvalidFechaOperacion: true
                            }
                          );
                      } else {
                        updateObservable = this.fileService.updateTicketById(
                          this.data.id,
                          {
                            hasInvalidFechaOperacion: true
                          }
                        );
                      }

                      return updateObservable.pipe(
                        tap(() => {
                          this.hasInvalidFechaOperacion = true;

                          Swal.fire({
                            icon: 'error',
                            title: 'Fechas no coinciden',
                            text: `La fecha del documento NO coincide con la fecha del servicio, fecha del servicio ${this.data.fecha}.`,
                            showConfirmButton: true
                          });
                        }),
                        map(() => response),
                        catchError((error) => {
                          console.error(
                            'Error updating invalid fecha operacion:',
                            error
                          );
                          return of(response);
                        })
                      );
                    }
                    return of(response);
                  }
                }
                return of(response);
              }),
              tap((response: any) => {
                const key = response.payload?.Key || response.key;
                newImage.key = key;
                this.multimedia.push(newImage);
              }),
              catchError((error) => {
                console.error(`Error al subir archivo ${file.name}:`, error);
                console.error(
                  'Error completo:',
                  JSON.stringify(error, null, 2)
                );

                let errorMessage = `Error al subir ${file.name}`;
                if (error.status === 401) {
                  errorMessage = `Error de autenticación al subir ${file.name}. Token expirado o inválido.`;
                  console.error(
                    'Error 401: Token de autenticación inválido o expirado'
                  );
                } else if (error.status === 403) {
                  errorMessage = `No tienes permisos para subir ${file.name}`;
                } else if (error.status === 500) {
                  errorMessage = `Error del servidor al procesar ${file.name}`;
                } else if (error.status === 413) {
                  errorMessage = `El archivo ${file.name} es demasiado grande`;
                } else if (error.status === 0) {
                  errorMessage = `Error de conexión al subir ${file.name}. Verifica tu conexión a internet.`;
                } else if (error.name === 'TimeoutError') {
                  errorMessage = `Timeout al subir ${file.name}. El archivo puede ser muy grande.`;
                } else {
                  errorMessage = `Error ${
                    error.status || 'desconocido'
                  } al subir ${file.name}: ${
                    error.message ||
                    error.statusText ||
                    'Sin detalles adicionales'
                  }`;
                }

                Swal.fire({
                  icon: 'error',
                  title: 'Error al subir archivo',
                  text: errorMessage
                });
                return of(null);
              })
            )
          );
        }
      });

      if (uploadRequests.length > 0) {
        forkJoin(uploadRequests).subscribe({
          next: () => {
            // this.zone.run(() => {
            this.uploading = false;
            this.isLoading = false; // Ensure loading is off after all uploads finish
            // });

            if (this.data && this.multimedia.length > 0) {
              this.updateHasDocument(this.data.id, true);
            }
          },
          error: () => {
            // this.zone.run(() => {
            this.isLoading = false;
            this.uploading = false;
            // });

            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ocurrió un error al subir archivos.'
            });
          }
        });
      } else {
        this.uploading = false;
      }
    } catch (error) {
      console.error('Error en onFileSelected:', error);
      this.uploading = false;

      let errorMessage = 'Ocurrió un error al procesar los archivos';
      if (error instanceof Error) {
        errorMessage = error.message.includes('No access token')
          ? 'Error de autenticación: no se pudo obtener el token de acceso. Por favor, inicia sesión nuevamente.'
          : `Error: ${error.message}`;
      }

      Swal.fire({
        icon: 'error',
        title: 'Error de Autenticación',
        text: errorMessage
      });
    }
  }

  async updateHasInvalidFechaOperacion(hasInvalidFechaOperacion: boolean) {
    if (this.data.serviceType === SERVICE_TYPES.TICKET) {
      let updateObservable;
      if (!this.data.isTicketItineraryService) {
        updateObservable =
          this.fileService.updateServiceTicketValidFechaOperacion({
            serviceId: this.data.id,
            hasInvalidFechaOperacion: hasInvalidFechaOperacion
          });
      } else {
        updateObservable = this.fileService.updateTicketById(this.data.id, {
          hasInvalidFechaOperacion
        });
      }

      updateObservable.subscribe({
        next: (data) => {
          this.iconResult = true;
          this.messageResult = 'Éxito';
          this.hasInvalidFechaOperacion = hasInvalidFechaOperacion;
        },
        error: (error) => {
          this.iconResult = true;
          this.messageResult = 'Error';
          console.error('Error en updateHasInvalidFechaOperacion:', error);
        }
      });
    }
  }

  async updateHasDocument(id: string, hasDocument: boolean): Promise<void> {
    const serviceId =
      this.data.serviceType === SERVICE_TYPES.TICKET ? this.data.id : id;

    if (!serviceId) {
      throw new Error('El id del servicio es necesario.');
    }

    const requests: Observable<any>[] = [];

    // Para ticketeria no afecta el has document del servicio
    if (!this.data.isTicketItineraryService) {
      requests.push(this.fileService.updateHasDocument(serviceId, hasDocument));
    }

    if (
      this.data.serviceType === SERVICE_TYPES.TICKET &&
      this.data.isTicketItineraryService
    ) {
      requests.push(
        this.fileService.updateTicketById(id, {
          hasDocument,
          estadoTicket: 'CONFIRMADO'
        })
      );
    }

    if (requests.length > 0) {
      forkJoin(requests).subscribe({
        next: (data) => {
          this.iconResult = true;
          this.messageResult = 'Éxito';
          this.hasDocument = hasDocument;
        },
        error: (error) => {
          this.iconResult = true;
          this.messageResult = 'Error';
          console.error('Error en updateHasDocument:', error);
        }
      });
    }
  }

  getDetailMultimedia = async (mediaElement: any) => {
    try {
      // Obtener headers de autenticación
      const headers = await this.getAuthHeaders();

      const partSize = 1_000_000;
      const totalParts = Math.ceil(mediaElement.Size / partSize);
      const fileData: any[] = [];

      const promises = Array.from({ length: totalParts }, (_, i) => {
        const endpoint = `/downloadFilePart/${mediaElement.Key}/${i}/${partSize}`;
        const url = `${this.s3ServiceRoute}${endpoint}`;

        return this.http
          .get(url, { headers }) // Agregar headers de autenticación
          .toPromise()
          .then((res: any) => {
            fileData[i] = res?.data;
          })
          .catch((error) => {
            console.error(`Error descargando parte ${i}:`, error);
            throw error;
          });
      });

      await Promise.all(promises);

      const combinedLength = fileData.reduce(
        (acc, part) => acc + part?.length,
        0
      );
      const combinedBuffer = new Uint8Array(combinedLength);
      let offset = 0;

      fileData.forEach((part) => {
        combinedBuffer.set(part, offset);
        offset += part?.length;
      });

      let binary = '';
      for (let i = 0; i < combinedBuffer.length; i++) {
        binary += String.fromCharCode(combinedBuffer[i]);
      }

      const split =
        this.data.serviceType === 10
          ? mediaElement.Key.split('/')
          : mediaElement.Key.split(';');
      const fileNameWithExtension = split.pop();

      const image = {
        src: binary,
        key: mediaElement.Key,
        name: fileNameWithExtension,
        nameDownload: fileNameWithExtension
      };

      this.multimedia.push(image);
    } catch (error) {
      console.error('Error al obtener el archivo en partes:', error);
      console.error('Archivo que falló:', mediaElement);

      if (error instanceof Error) {
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
      }

      // Re-lanzar el error para que sea capturado por getAllMultimedia
      throw error;
    }
  };

  async getAllMultimedia() {
    this.isLoading = true;
    try {
      // Obtener headers de autenticación
      const headers = await this.getAuthHeaders();

      const endpoints = {
        1: `/getFiles/${this.data.fileId}/${this.data.id}`,
        2: `/getFilesTransporte/${this.data.fileId}/${this.data.id}`,
        3: `/getFilesTren/${this.data.fileNumber}/${this.data.id}`,
        4: `/getFilesGuias/${this.data.fileId}/${this.data.id}`,
        5: `/getFilesOperadores/${this.data.fileId}/${this.data.id}`,
        6: `/getFilesCoordinadores/${this.data.fileId}/${this.data.id}`,
        7: `/getFilesHotel/${this.data.fileId}/${this.data.id}`,
        10: `/getFilesItinerary/${this.data.fileId}`,
        11: `/getFilesTemplate`,
        [`${SERVICE_TYPES.TICKET}`]: `/getFilesTicket/${this.data.fileId}/${this.data.serviceId}/${this.data.id}`
      };

      let extraResponse: any = [];

      if (
        this.data.serviceType === 3 &&
        (this.data.categoriaServicio === 'ENTRADA' ||
          this.data.categoriaServicio === 'TREN')
      ) {
        const extraUrl = `${this.s3ServiceRoute}/getFiles/${this.data.fileNumber}/${this.data.id}`;
        const extraUrl2 = `${this.s3ServiceRoute}/getFilesTicket/${this.data.fileId}/${this.data.serviceId}/${this.data.id}`;
        try {
          const [res1, res2] = await Promise.allSettled([
            firstValueFrom(this.http.get(extraUrl, { headers })),
            firstValueFrom(this.http.get(extraUrl2, { headers }))
          ]);

          // ✅ Extraer arrays de las respuestas
          const data1 =
            res1.status === 'fulfilled'
              ? Array.isArray(res1.value)
                ? res1.value
                : Object.values(res1.value) // si viene como objeto
              : [];

          const data2 =
            res2.status === 'fulfilled'
              ? Array.isArray(res2.value)
                ? res2.value
                : Object.values(res2.value)
              : [];

          // ✅ Combinar ambos arrays
          extraResponse = [...data1, ...data2];
        } catch (extraErr) {
          console.error('Error obteniendo extraResponse:', extraErr);
          extraResponse = [];
        }
      }

      const endpoint =
        endpoints[this.data.serviceType] ??
        `/getFilesReserva/${this.data.reservaId}`;
      const mainUrl = `${this.s3ServiceRoute}${endpoint}`;

      const response: any = await firstValueFrom(
        this.http.get(mainUrl, { headers })
      );

      const archivosTotales = [...(response ?? []), ...(extraResponse ?? [])];
      this.archivos = archivosTotales.length;

      if (archivosTotales.length > 0) {
        // Usar Promise.allSettled en lugar de Promise.all para manejar errores individuales
        const results = await Promise.allSettled(
          archivosTotales.map((multimediaItem: any) =>
            this.getDetailMultimedia(multimediaItem)
          )
        );

        // Contar archivos exitosos y fallidos
        const successful = results.filter(
          (r) => r.status === 'fulfilled'
        ).length;
        const failed = results.filter((r) => r.status === 'rejected').length;

        // Mostrar errores específicos
        results.forEach((result, index) => {
          if (result.status === 'rejected') {
            console.error(`Error procesando archivo ${index}:`, result.reason);
          }
        });

        if (failed > 0) {
          console.warn(
            `Se produjeron ${failed} errores al cargar archivos multimedia`
          );
        }
      }
    } catch (error) {
      console.error('Error al obtener multimedia:', error);
      if (error instanceof Error) {
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
      }
      // Mostrar un mensaje más específico al usuario
      this.messageResult = 'Error al cargar los archivos multimedia';
      this.iconResult = 'error';
    } finally {
      this.isLoading = false;
    }
  }

  downloadFile(multimedia: any) {
    const split = multimedia.src.split(',');

    const type = split[0];
    const binary = split[1];

    const byteCharacters = atob(binary);
    const byteNumbers = new Array(byteCharacters?.length);
    for (let i = 0; i < byteCharacters?.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: type });
    FileSaver.saveAs(blob, multimedia.name);
  }

  deleteMultimedia(multimediaElement: any, i: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = '512px';
    dialogConfig.minHeight = '340px';

    dialogConfig.data = {
      serviceType: this.data.serviceType,
      generalId: this.data.id,
      mediaElement: multimediaElement,
      updateHasDocument: this.updateHasDocument.bind(this),
      multimediaCant: this.multimedia.length,
      multimedias: this.multimedia
    };
    let dialogRef = this.dialog.open(DialogConfirmComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.success === true) {
          this.notificationService.showSuccessAlertPersonalizado(
            'Eliminado',
            'El documento se eliminó correctamente.'
          );
          this.multimedia.splice(i, 1);

          if (
            this.data.serviceType === SERVICE_TYPES.TICKET &&
            (this.multimedia.length === 0 ||
              (this.multimedia.length > 0 &&
                !this.multimedia.some((multimedia: any) =>
                  multimedia.name.includes('FECHA DE OPERACION NO COINCIDE')
                )))
          ) {
            this.isLoading = true;

            let updateObservable;
            if (!this.data.isTicketItineraryService) {
              updateObservable =
                this.fileService.updateServiceTicketValidFechaOperacion({
                  serviceId: this.data.id,
                  hasInvalidFechaOperacion: false
                });
            } else {
              updateObservable = this.fileService.updateTicketById(
                this.data.id,
                {
                  hasInvalidFechaOperacion: false
                }
              );
            }

            firstValueFrom(updateObservable)
              .then((hasInvalidFechaOperacionRes) => {
                this.hasInvalidFechaOperacion = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        }
      }
    });
  }

  activatePDF(multimedia: any, index: any) {
    if (index == this.index) {
      this.pdfViewer = false;
      this.index = null;
    } else {
      this.index = index;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(multimedia.src);
      this.pdfViewer = true;
    }
  }

  onCancel() {
    this.dialogRef.close({
      serviceId: this.data.id,
      changeIconColor: this.hasDocument,
      hasInvalidFechaOperacion: this.hasInvalidFechaOperacion,
      isTicketItineraryService: this.data.isTicketItineraryService
    });
  }

  ngOnDestroy(): void {
    this.onCancel();
  }
}
